export const apiName: string = 'odometros-horimetros';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/odometros-horimetros/shared/data.service.ts
 **/